const { fetchAuthorizedJsonApi, fetchJsonApi } = require('./abstract');
const { getApiLanguage } = require('./language');

const endpoint = 'v1/legal-data';

const fetchLegalData = (apiUrl, { platform, versionCode } = {}) =>
  fetchJsonApi({
    method: 'GET',
    apiUrl,
    endpoint,
    query: { platform, versionCode, lang: getApiLanguage() },
    expectedStatus: 200,
    description: 'Fetching legal data',
  });

const setLegalDataConsent = (apiUrl, token, { legalData, consentedAt }) =>
  fetchAuthorizedJsonApi({
    apiUrl,
    method: 'PUT',
    endpoint: `${endpoint}/consent/${legalData}`,
    token,
    expectedStatus: 204,
    description: 'Setting legal data consent',
    body: { consentedAt },
  });

module.exports = {
  fetchLegalData,
  setLegalDataConsent,
};
